module.exports = __webpack_public_path__ + "static/anuel_llnm-41ae09cded931d67c1fdafdcf9c33c03.jpg";